import React from 'react';
import '../assets/styles/Contact.scss';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const EMAIL = 'jmfpinto1@gmail.com';
const LINKEDIN_URL = 'https://www.linkedin.com/in/joao-pinto-/';

function Contact() {
  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contacto</h1>

          <div className="contact-links">
            <a href={`mailto:${EMAIL}`} className="contact-link">
              <EmailIcon />
              <span>{EMAIL}</span>
            </a>

            <a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="contact-link">
              <LinkedInIcon />
              <span>LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;